const AttachType = Object.freeze({
  PDF: 0,
  XLSX: 1,
  ZPI: 2
})

export {
  AttachType
}
